// Modules
import { ReactElement } from "react"

// Utils
import checkAuthorization from "./utils/checkAuthorization"

export interface IsAuthorizedProps {
  action: string
  children: ReactElement
  data?: any
}

const IsAuthorized = ({ action, data, children }: IsAuthorizedProps) => {
  return checkAuthorization(action, data) ? children : null
}

export default IsAuthorized
